import { IFeatureBase, IFeatureGroupBase } from '../../models/features';
import { IVentureBase } from '../../models/ventures';
import {
  IUserBase,
  IUserOnboardBase,
  IUserAssignmentBase,
} from '../../models/users';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';
import { IAddressEntity } from '../../models/address';
import { IVentureExperienceLevelBase } from '../../models/ventureExperienceLevels';

interface ICreateSessionProps {
  email: string;
  password: string;
  ventureId?: string;
}

export interface ISessionFeatureGroup extends IFeatureGroupBase {
  features: IFeatureBase[];
}

export interface ISessionVenture extends IVentureBase {
  experienceLevels: IVentureExperienceLevelBase[];
}

interface ISessionUserAssignment extends IUserAssignmentBase {
  featureGroup: IFeatureGroupBase;
  venture?: IVentureBase;
}

export interface ISessionUser extends IUserBase {
  address?: IAddressEntity;
  userAssignments: ISessionUserAssignment[];
}

export interface INewSessionUserAssignment extends IUserAssignmentBase {
  featureGroup: ISessionFeatureGroup;
}

export interface INewSession {
  user: ISessionUser;
  sessionUserAssignment: INewSessionUserAssignment;
  sessionUserVentureOnboard?: IUserOnboardBase;
  sessionVenture?: ISessionVenture;
  token: string;
  refreshToken: string;
}

export const authenticateSessionsService = async ({
  email,
  password,
  ventureId,
}: ICreateSessionProps): Promise<INewSession> => {
  const { data } = await jhsfBookingsApi.post<INewSession>('/v2/sessions', {
    email,
    password,
    ventureId,
  });

  return data;
};
